import { Typography } from "@mui/material";
import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Body from "../../ui/Body";
import Edit from "./Edit";

export default function CouponList() {


  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <Edit />
      </Body>
    </>
  );
}
